import { baseApi } from '../app/baseApi';
import { Mentor } from '../../../shared/src/types/Mentor';
import { BaseFamily } from '../../../shared/src/types/Family';
import { NewUser, User } from '@mekimix/shared/src/types/User';
export const adminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMentors: builder.query<Mentor[], void>({
      query: () => '/admin/mentors',
      transformResponse: (response: { success: boolean; data: Mentor[] }) => response.data,
    }),
    getFamilies: builder.query<BaseFamily[], void>({
      query: () => '/families',
      transformResponse: (response: { success: boolean; data: BaseFamily[] }) => response.data,
    }),
    updateMentorStatus: builder.mutation<void, { id: string; active: boolean }>({
      query: ({ id, active }) => ({
        url: `/admin/mentors/${id}/status`,
        method: 'PUT',
        body: { active },
      }),
      invalidatesTags: ['Mentor'],
    }),
    addMentor: builder.mutation<User, NewUser>({
      query: (newUser) => ({
        url: "/admin/addMentor",
        method: "POST",
        body: newUser,
      }),
      invalidatesTags: ['Mentor'],
    }),
  }),
});

export const {useGetMentorsQuery, useGetFamiliesQuery,useUpdateMentorStatusMutation,useAddMentorMutation,} = adminApi;